import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { IconButton, Row, useTheme, Column, AppText, Box, styled, } from '@streem/ui-react';
import MutedOnEnteringCallModal from './muted_on_entering_call_modal';
import MutedOnCallMessage from './muted_on_call_message';
import { EndCallButton } from '../in_call/tool_bar/tools/end_call_button';
import { logger } from '../../util/logger';
export function Controls({ audioState, videoState, inCall, onEndCallButtonClicked }) {
    const { enabled: audioEnabled, toggleEnabled: toggleAudioEnabled, notAvailable: audioNotAvailable, showMicTroubleshootingMessage, } = audioState;
    const { enabled: videoEnabled, toggleEnabled: toggleVideoEnabled, notAvailable: videoNotAvailable, showCameraTroubleshootingMessage, } = videoState;
    const microphoneMuteStatus = audioEnabled ? 'Mute' : 'Muted';
    const [showMuteModalOnEntry, setShowMuteModalOnEntry] = useState(true);
    const [showMuteModalOnCall, setShowMuteModalOnCall] = useState(false);
    const theme = useTheme();
    useEffect(() => {
        setShowMuteModalOnEntry(!!(microphoneMuteStatus === 'Muted' && inCall && showMuteModalOnEntry));
    }, [microphoneMuteStatus, inCall, showMuteModalOnEntry]);
    const handleUnmuteClick = useCallback(() => {
        toggleAudioEnabled();
        setShowMuteModalOnEntry(false);
    }, [toggleAudioEnabled]);
    const handleAudioMuteButtonClicked = () => {
        if (audioNotAvailable) {
            if (showMicTroubleshootingMessage) {
                showMicTroubleshootingMessage();
            }
            else {
                logger.warn('Audio is unavailable and showMicTroubleshootingMessage is not defined');
                return;
            }
        }
        else {
            toggleAudioEnabled();
            setShowMuteModalOnCall(!!(audioEnabled && inCall && !showMuteModalOnEntry));
        }
    };
    const handleCameraMuteButtonClicked = () => {
        if (videoNotAvailable) {
            if (showCameraTroubleshootingMessage) {
                showCameraTroubleshootingMessage();
            }
            else {
                logger.warn('Video is unavailable and showCameraTroubleshootingMessage is not defined');
                return;
            }
        }
        else {
            toggleVideoEnabled();
        }
    };
    return (_jsxs(_Fragment, { children: [showMuteModalOnCall && _jsx(MutedOnCallMessage, {}), _jsxs(ControlsContainer, { inCall: inCall, children: [_jsxs(Column, { alignItems: "center", flexBasis: !inCall ? '50%' : undefined, children: [_jsxs("div", { style: { position: 'relative' }, children: [audioNotAvailable && _jsx(MediaNotAvailableIndicator, {}), _jsx(SwitchButton, { active: {
                                            icon: 'MuteIcon',
                                        }, inactive: {
                                            icon: 'MutedIcon',
                                        }, slashColor: theme.colors.red50, testId: audioNotAvailable
                                            ? 'mic-toggle-btn-not-available'
                                            : `mic-toggle-btn-${audioEnabled ? 'on' : 'off'}`, label: 'Microphone', state: audioNotAvailable ? true : audioEnabled, handleClick: handleAudioMuteButtonClicked, inCall: inCall })] }), !inCall && (_jsx(Box, { marginTop: 3, textAlign: "center", children: _jsx(AppText, { color: "medium", children: audioNotAvailable ? 'Unavailable' : microphoneMuteStatus }) }))] }), inCall && _jsx(EndCallButton, { onClicked: onEndCallButtonClicked, host: true }), _jsxs(Column, { alignItems: "center", flexBasis: !inCall ? '50%' : undefined, children: [_jsxs("div", { style: { position: 'relative' }, children: [videoNotAvailable && _jsx(MediaNotAvailableIndicator, {}), _jsx(SwitchButton, { active: {
                                            icon: 'CameraIcon',
                                        }, inactive: {
                                            icon: 'CameraOffIcon',
                                        }, slashColor: theme.colors.red50, testId: `camera-toggle-btn-${videoEnabled ? 'on' : 'off'}`, label: 'Camera', state: videoNotAvailable ? true : videoEnabled, handleClick: handleCameraMuteButtonClicked, inCall: inCall })] }), !inCall && (_jsx(Box, { marginTop: 3, children: _jsx(AppText, { color: "medium", children: videoNotAvailable ? 'Unavailable' : 'Camera' }) }))] }), !audioNotAvailable && showMuteModalOnEntry && (_jsx(MutedOnEnteringCallModal, { handleUnmuteClick: handleUnmuteClick, handleCloseModal: () => setShowMuteModalOnEntry(false) }))] })] }));
}
const ControlsContainer = ({ children, inCall, }) => {
    return (_jsx(Row, { margin: "16px auto 0px", justifyContent: "space-evenly", mt: inCall ? '' : 4, mb: inCall ? 4 : '', flexGrow: 1, zIndex: 3, maxWidth: "500px", children: children }));
};
function SwitchButton({ state, inCall, testId, fillLevel, slashColor, handleClick, label, active, inactive, }) {
    const theme = useTheme();
    const activeInCall = inCall && state;
    return (_jsx(IconButton, { size: 'CVLarge', "data-testid": testId, background: activeInCall ? 'whiteA20' : 'grey10', fill: activeInCall
            ? theme.colors.white
            : !activeInCall
                ? theme.colors.grey50
                : theme.colors.red50, slashcolor: slashColor, fillLevel: fillLevel, onClick: handleClick, iconName: state ? active.icon : inactive.icon, label: label, iconSize: "30px" }));
}
const MediaNotAvailableIndicator = styled.div `
    position: absolute;
    background: ${props => props.theme.colors.white};
    box-shadow: ${props => props.theme.shadow.small};
    bottom: 0;
    height: 22px;
    width: 22px;
    right: 0;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 4px;
        background-color: ${props => props.theme.colors.red50};
        text-align: center;
        transform: scale(0.5, 0.5) rotate(45deg);
    }
    &:after {
        position: absolute;
        content: '';
        width: 100%;
        height: 4px;
        background-color: ${props => props.theme.colors.red50};
        text-align: center;
        transform: scale(0.5, 0.5) rotate(-45deg);
    }
`;
//# sourceMappingURL=controls.js.map